import type { Response } from 'express';
import { HTTPStatusCode } from '@sbt-web/network/types';
import { ClientHintsContextData } from '@sbt-web/hooks';
import type { StickyBannerContent } from '@sbt-web/header';
import { Theme } from '@/shared/helpers/Themes';
import { DeviceType } from '@/shared/helpers/DeviceDetector';
import type { Props as FourTenProps } from '@/client/components/Scaffolding/Errors/410';

export type GonePageProps = {
  statusCode: HTTPStatusCode.Gone;
} & FourTenProps;

export function setStatusOnServer<T extends HTTPStatusCode>(
  statusCode: T,
  res: Response | undefined
): { statusCode: T } {
  if (res) {
    res.status(statusCode);
  }

  return { statusCode };
}

export type BasePageProps = {
  statusCode: HTTPStatusCode;
  theme: Theme;
  pageName: string;
  deviceType?: DeviceType | null;
  clientHints?: ClientHintsContextData;
  categorySlug?: string | string[];
  stickyBannerContent?: StickyBannerContent;
} & (
  | GonePageProps
  | { statusCode: Exclude<HTTPStatusCode, HTTPStatusCode.Gone> }
);
